import { useCallback } from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import { useFeatureFlags } from '../hooks';

const FeatureFlagMenuItem = ({ feature }: { feature: { key: string; title: string; description: string } }) => {
  const { features, toggleFeature } = useFeatureFlags();

  const handleToggleFeature = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation();
      toggleFeature(feature.key);
    },
    [feature.key, toggleFeature]
  );

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack>
        <Typography variant="body1">{feature.title}</Typography>
        <Typography variant="body2">{feature.description}</Typography>
      </Stack>
      <Switch
        checked={!!features[feature.key]}
        data-testid={`feature-flag-${feature.key}`}
        onChange={handleToggleFeature}
      />
    </Stack>
  );
};

export default FeatureFlagMenuItem;
